export default __webpack_public_path__ + "static/media/transcription-icon.1636bdb0.svg";